module.exports = __webpack_public_path__ + "./images/docent-man-150.png?33b575c6eec326a7680670b7705a2666";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/docent-man-150.png
// module id = 90
// module chunks = 0